import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

class Grecaptcha extends React.Component {
    constructor(props) {
        super(props);
        this.grecaptchaId = null;

        this._onSubmit = this._onSubmit.bind(this);
        this._onCaptchaResponse = this._onCaptchaResponse.bind(this);
    }

    componentDidMount() {
        const { grecaptchaApiKey, setGrecaptchaId, elementId, size } = this.props;

        const initializeGrecaptcha = () => {
            // grecaptcha.ready allows us to avoid a race condition with the loading of the grecaptcha api
            grecaptcha.ready(() => {
                this.grecaptchaId = grecaptcha.render(elementId, {
                    sitekey: grecaptchaApiKey,
                    size,
                    callback: this._onCaptchaResponse
                });

                setGrecaptchaId(this.grecaptchaId);
            });
        };

        const waitForGrecaptcha = () => {
            if (window.grecaptcha && typeof grecaptcha.ready === "function") {
                initializeGrecaptcha();
            
                return;
            }

            setTimeout(() => {
                waitForGrecaptcha();
            }, 100);
        };

        waitForGrecaptcha();
    }

    _onSubmit(event) {
        event.preventDefault();

        grecaptcha.execute(this.grecaptchaId);
    }

    _onCaptchaResponse() {
        const grecaptchaToken = grecaptcha.getResponse();

        this.props.onCaptchaResponse(grecaptchaToken);

        grecaptcha.reset(this.grecaptchaId);
    }

    render() {
        const { hiddenOnMobile, elementId } = this.props;

        return <div id={ elementId } className={ hiddenOnMobile ? styles.hiddenOnMobile : "" } />;
    }
}

Grecaptcha.propTypes = {
    onCaptchaResponse: PropTypes.func.isRequired,
    grecaptchaApiKey: PropTypes.string.isRequired,
    hiddenOnMobile: PropTypes.bool,
    elementId: PropTypes.string.isRequired,
    setGrecaptchaId: PropTypes.func,
    size: PropTypes.string.isRequired
};

export default Grecaptcha;
